import { render, staticRenderFns } from "./PatternEditProfileForm.vue?vue&type=template&id=05cf87c5&"
import script from "./PatternEditProfileForm.vue?vue&type=script&lang=js&"
export * from "./PatternEditProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports